import React, { useState } from "react";
import "./weather.css";
import axios from "axios";
import WeatherInfo from "./WeatherInfo";
import WeatherForecast from "./WeatherForecast";

export default function Weather(props) {
  const [weatherData, setWeatherData] = useState({ ready: false });
  const [city, setCity] = useState(props.defaultCity);
  function handleResponse(response) {
    setWeatherData({
      ready: true,
      coordinates: response.data.coord,
      temperature: response.data.main.temp,
      wind: response.data.wind.speed,
      city: response.data.name,
      humidity: response.data.main.humidity,
      iconUrl: `http://openweathermap.org/img/wn/${response.data.weather[0].icon}@2x.png`,
      description: response.data.weather[0].description,
      date: new Date(response.data.dt * 1000),
    });
  }

  function handleSubmit(event) {
    event.preventDefault();
    search();
  }

  function handleCityChange(event) {
    setCity(event.target.value);
  }

  function search() {
    const apiKey = "12f35b27492677297a3092d359a9b88f";
    let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
    axios.get(apiUrl).then(handleResponse);
  }

  if (weatherData.ready) {
    return (
      <div className="Weather">
        <header>Nicole's Weather Forecast</header>
        <div className="weather-card">
          <form className="search-form" onSubmit={handleSubmit}>
            <input
              type="search"
              placeholder="Enter city here..."
              className="city-input"
              autocomplete="off"
              onChange={handleCityChange}
            />
            <input type="submit" value="Search" className="btn btn-primary" />
          </form>
          <WeatherInfo data={weatherData} />
          <WeatherForecast coordinates={weatherData.coordinates} />
        </div>
        <footer>
          This code was created by Nicole Jones, view on<span> </span>
          <a
            href="https://github.com/nicolemariej/react-weather-project"
            target="_blank"
            rel="noreferrer"
          >
            Open Source Code
          </a>
        </footer>
      </div>
    );
  } else {
    search();
    return "Loading...";
  }
}
